// extracted by mini-css-extract-plugin
export default {"error":"Shopping_error__3ywmK"};